
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function useAdminAccess() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminAccess = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.user) {
          navigate('/');
          return;
        }

        const { data: profile, error } = await supabase
          .from('profiles')
          .select('is_admin')
          .eq('id', session.user.id)
          .single();

        if (error || !profile?.is_admin) {
          toast.error("You don't have permission to access this page");
          navigate('/');
          return;
        }

        setIsLoading(false);
      } catch (error: any) {
        toast.error(error.message);
        navigate('/');
      }
    };

    checkAdminAccess();
  }, [navigate]);

  return { isLoading };
}
